import { Object3D, PerspectiveCamera, Vector3 } from "three";
import { Main } from "../../Main";
import { AccessoryPlacer } from "./AccessoryPlacer";
import { AssetLoader } from "../../assets/AssetLoader";
import { AddonManager } from "../../scene/addon/AddonManager";

interface IAccessoryConfig
{
	placer: AccessoryPlacer;
	originalConfig: {
		id: string;
		rotation: number[];
		position: number[];
	};
	scene: Object3D;
}

/**
 * Accessories are 3d models to show/hide beside the building for size references.
 * Eg.: truck, person.
 */
export class Accessory
{
	private _modelName : string;
	private _loader : AssetLoader;
	private _scene  : Object3D;
	private _mesh   : Object3D;
	private _hidden : boolean = true;
	private _rot    : number[];
	private _pos    : number[];

	private _placer: AccessoryPlacer;

	constructor(config: IAccessoryConfig)
	{

		this._scene = config.scene;
		this._rot = config.originalConfig.rotation;
		this._pos = config.originalConfig.position;
		this._placer = config.placer;

		this._loader = new AssetLoader();
		this._loader.loadedSignal.add(this.onLoaded);
		this._modelName = config.originalConfig.id;
		//this._mesh = this._scene.getObjectByName(this._modelName);
		this.onLoaded(AddonManager.getInstance().createMesh(this._modelName));
	}

	private onLoaded = (result:Object3D) =>
	{
		this._mesh = result;
		this._mesh.castShadow = true;

		this._scene.add(this._mesh);

		if (this._hidden)
		{
			this._mesh.visible = false;
		}

		var deg2rad = Math.PI/180;
		this._mesh.rotation.x += this._rot[0] * deg2rad;
		this._mesh.rotation.y += this._rot[1] * deg2rad;
		this._mesh.rotation.z += this._rot[2] * deg2rad;

		this.setPosition();
		//this.setDefaultPosition();
		Main.getInstance().config.building.width.signal.add(this.onBuildingWidthChange);

		Main.getInstance().render = true;
	};

	public show()
	{
		this._hidden = false;

		if (this._mesh)
		{
			this._mesh.visible = true;
		}

		Main.getInstance().render = true;
	}

	public hide()
	{
		this._hidden = true;

		if (this._mesh)
		{
			this._mesh.visible = false;
		}

		Main.getInstance().render = true;
	}

	private onBuildingWidthChange = () =>
	{

	}

	public updatePosition = (position: number[], camera: PerspectiveCamera): boolean =>
	{

		var point = this._placer.hitTest(position, camera);

		console.log(point);

		if (point)
		{
			this.setPosition([
				point.x,
				point.y,
				point.z
			]);
		}

		///
		///
		///

		// Some of it taken from NodePlacer
		//var x =   position[0];
		//var y = - position[1];

		//
		//var node   = this._scene.placingAddon;
		//var camera = this._content.camera;
		//var vector = new Vector3(x, y, 0);
		//this._projector.unprojectVector(vector, camera);
		//
		//this._raycaster.set(camera.position, vector.sub(camera.position).normalize());
		//
		//var hit = node.checkPlacing(this._raycaster, this._scene, this);
		//
		//window.document.body.style.cursor = hit ? "move" : "";
		return true;
	}

	private setDefaultPosition()
	{
		var config = Main.getInstance().config.building;

		this.setPosition([
			config.width.value/2 + this._pos[0],
			this._pos[1],
			this._pos[2]
		]);
	}

	public placeNode()
	{
		return true;
	}

	public getPlacingNodeHasValidPlace()
	{
		return true;
	}

	public get rotation()
	{
		return this._rot;
	}

	public setPosition(position?: number[])
	{
		// either use param, or default to _pos (when the mesh has been loaded)
		position = position || this._pos;
		this._pos = position;

		if (this._mesh)
		{
			this._mesh.position.x = position[0];
			this._mesh.position.y = position[1];
			this._mesh.position.z = position[2];
		}

		Main.getInstance().render = true;
	}

	public setRotation(rotation: Vector3)
	{
		this._rot = [rotation.x, rotation.y, rotation.z];

		if (this._mesh)
		{
			this._mesh.rotation.x = rotation.x;
			this._mesh.rotation.y = rotation.y;
			this._mesh.rotation.z = rotation.z;
		}

		Main.getInstance().render = true;
	}

	public get position()
	{
		return this._pos;
	}
}